import { createContext } from 'react'
import { StoreApi } from 'zustand'
import { PatientProfile, ProfileStatus } from '@/lib/apis/types'
import { Session } from 'next-auth'
import { PersonalDetailsFormState } from '@/shared/request/PersonalDetailsFormStage'
import { IHIVerificationState } from '@/shared/components/hi/HealthcareIdentifierForm'

interface FormState {
  session: Session | null
  initialProfile: PatientProfile | null
  profileStatus: ProfileStatus | null
  profileFormState: PersonalDetailsFormState
  ihiVerificationState: IHIVerificationState
  verifiedIdentifierAttachmentPending: boolean
  updateProfileFormState: (
    updater: (state: PersonalDetailsFormState) => PersonalDetailsFormState,
  ) => void
  setVerifiedIdentifierAttachmentPending: (pending: boolean) => void
  completeVerifiedIdentifierAttachment: (
    profileStatus: ProfileStatus | null,
  ) => void
  returnToIdentifierCorrection: () => void

  onNext: () => void
  onPrev: () => void
}

type PersonalDetailsFormStore = StoreApi<FormState>
export const PersonalDetailsFormContext =
  createContext<PersonalDetailsFormStore | null>(null)
